// extracted by mini-css-extract-plugin
module.exports = {"agrosYellow":"#29b7e3","agrosYellowDark":"#29b7e3","agrosGreen":"#093559","eocOrange":"#ffc72c","agrosBlackGrey":"#111","agrosBlack":"#093559"};